










import Vue from 'vue'
import * as types from '@/store/modules/play/types'

export default Vue.extend({
  name: 'ResetButton',

  props: {
    isPlaying: Boolean,
    isCountdown: Boolean,
  },

  computed: {
    /**
     * 選択中のトラックインデックス
     */
    selectedTrackIndex (): types.TrackIndex {
      return this.$store.state[types.moduleName].selectedTrackIndex
    },

    /**
     * トラックに配置されている音を取得
     */
    sounds (): types.SoundOnScore[] {
      return this.$store.state[types.moduleName].score.filter((sound: types.SoundOnScore) => {
        return sound.trackIndex === this.selectedTrackIndex
      })
    },

    /**
     * 選択中のトラックに音が配置されているか
     */
    hasSoundInActiveTrack (): boolean {
      return this.sounds.length > 0
    },

    /**
     * ボタン使用不可
     */
    isDisabled (): boolean {
      return !this.hasSoundInActiveTrack || this.isPlaying || this.isCountdown
    },
  },

  methods: {
    /**
     * トラックの音を全削除
     */
    resetTackSound () {
      this.$store.commit(`${types.moduleName}/${types.Mutation.SCORE.RESET}`, this.selectedTrackIndex)
    },
  },
})
